// Copyright 2020 Sorama B.V.

import { bindable, computedFrom, customElement } from "aurelia-framework";

@customElement("circular-progress")
export class CircularProgress {
    /**
     * Number between 0 and 100
     */
    @bindable
    public progress: number;

    /**
     * Optional sub text in the progress bar, besides the percentage
     */
    @bindable
    public subtext: string;

    @computedFrom("progress")
    protected get offset(): number {
        return this.circumference - (this.progress / 100) * this.circumference;
    }

    protected readonly strokeWidth = 8;
    protected readonly radius = (100 - 2 * this.strokeWidth) / 2;
    protected readonly circumference = this.radius * 2 * Math.PI;
}
